import { useState, useEffect } from 'react';
import {
  normalizeMatchStartTime,
  formatElapsedMmSs,
} from '../utils/matchTimerUtils';

/**
 * Tick elapsed seconds from a match start anchor while active.
 * @param {Date|string|null|undefined} startTime
 * @param {boolean} isActive
 * @returns {{ elapsedSeconds: number, formattedMmSs: string }}
 */
export function useElapsedSeconds(startTime, isActive) {
  const normalizedStart = normalizeMatchStartTime(startTime);

  const computeElapsed = () => {
    if (!isActive || !normalizedStart) return 0;
    const startMs = new Date(normalizedStart).getTime();
    return Math.max(0, Math.floor((Date.now() - startMs) / 1000));
  };

  const [elapsedSeconds, setElapsedSeconds] = useState(computeElapsed);

  useEffect(() => {
    if (!isActive || !normalizedStart) {
      setElapsedSeconds(0);
      return undefined;
    }

    setElapsedSeconds(computeElapsed());
    const interval = setInterval(() => {
      setElapsedSeconds(computeElapsed());
    }, 1000);

    return () => clearInterval(interval);
  }, [normalizedStart, isActive]);

  return {
    elapsedSeconds,
    formattedMmSs: formatElapsedMmSs(elapsedSeconds),
  };
}
